import React from "react";
import "./CoverageResultsStyle/CoverageResultsStyle.scss";

export const CoPayCard = props => {
    function setTwoDecimalNumber(event) {
        event.value = parseInt(event.target.value).toFixed(2);
    }
    return (
        <div className="margin_plan_details_card">
            <div className="in_network_label">{props.title}</div>
            <div className="individual_label">{props.details.level}</div>
            <div className="remaining_total_amount_name_out_of_pocket">
                {props.details?.payerNotes?.map(y => {
                    return (
                        <div>
                            {y}
                        </div>
                    )

                })}
                {!props.details?.payerNotes && (
                    <>
                        No Notes Available
                    </>
                )}
            </div>
            <div className="remaining_total_amount">${props.details.amount}</div>
            <div className="remaining_total_amount_label">Per Visit</div>
        </div>
    );
};
